import React, { useCallback, useEffect, useState } from 'react';
import Button from './Button';
import { fetchPendingReservations, decideReservation } from './ownerApi';
import './OwnerReservations.css';

function OwnerReservations() {
  const [reservations, setReservations] = useState(null);
  const [loadFailed, setLoadFailed] = useState(false);
  const [decidingId, setDecidingId] = useState(null);
  const [decisionError, setDecisionError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    fetchPendingReservations()
      .then((result) => {
        if (!cancelled) {
          setReservations(result);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setLoadFailed(true);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const handleDecision = useCallback(async (reservation, decision) => {
    setDecidingId(reservation.reservationId);
    setDecisionError(null);

    const result = await decideReservation(reservation.vehicleSlug, reservation.reservationId, decision);

    setDecidingId(null);

    if (result.outcome === 'error') {
      setDecisionError(result.error);
      return;
    }

    setReservations((previous) =>
      previous.filter((candidate) => candidate.reservationId !== reservation.reservationId)
    );
  }, []);

  if (loadFailed) {
    return (
      <section className="owner-reservations">
        <h1>Reservation requests</h1>
        <p role="alert">Could not load reservation requests. Please refresh the page.</p>
      </section>
    );
  }

  if (reservations === null) {
    return (
      <section className="owner-reservations">
        <h1>Reservation requests</h1>
        <p>Loading...</p>
      </section>
    );
  }

  return (
    <section className="owner-reservations">
      <h1>Reservation requests</h1>

      {decisionError && <p role="alert">{decisionError}</p>}

      {reservations.length === 0 ? (
        <p>No pending requests.</p>
      ) : (
        <ul className="owner-reservations__list">
          {reservations.map((reservation) => {
            const deciding = decidingId === reservation.reservationId;
            const context = `${reservation.vehicleSlug}, ${reservation.startDate} to ${reservation.endDate}`;

            return (
              <li key={reservation.reservationId} className="owner-reservations__item">
                <h2>{reservation.vehicleSlug}</h2>
                <p>
                  {reservation.startDate} to {reservation.endDate}
                </p>
                <p>
                  {reservation.name} &middot; {reservation.email}
                  {reservation.phone ? ` · ${reservation.phone}` : ''}
                </p>
                <div className="owner-reservations__actions">
                  <Button
                    variant="primary"
                    onClick={() => handleDecision(reservation, 'confirmed')}
                    disabled={deciding}
                    aria-label={`Approve reservation for ${context}`}
                  >
                    Approve
                  </Button>
                  <Button
                    variant="secondary"
                    onClick={() => handleDecision(reservation, 'declined')}
                    disabled={deciding}
                    aria-label={`Decline reservation for ${context}`}
                  >
                    Decline
                  </Button>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}

export default OwnerReservations;
